module.exports = __webpack_public_path__ + "img/case.226ea5aa.png";